import { gql, type OperationVariables } from '@apollo/client';
import { setCompanyAllSkills } from '@store/reducer/companyReducer';
import { setEmployeeSkills } from '@store/reducer/employeeReducer';
import { deleteSkill as deleteSkillReducerAction } from '@store/reducer/skillReducer';
import store from '@store/store';

import GraphQL from '../graphQL';

const query = gql`
mutation deleteSkill($id: Int!) {
    deleteSkill(id: $id) 
},
`;

/**
 * Deletes a skill.
 *
 * @param {number} id - The ID of the skill.
 * @returns {Promise<boolean>} A promise that resolves to a boolean value indicating if the skill was successfully deleted.
 */
export default async function deleteSkill(id: number) {
    const variables: OperationVariables = { id };
    return GraphQL.mutate<boolean>(query, variables).then((obj) => {
        const state = store.getState();
        store.dispatch(deleteSkillReducerAction(id));
        store.dispatch(setEmployeeSkills(state.employee.skills.filter((empEneity) => empEneity.id !== id)));
        store.dispatch(setCompanyAllSkills(state.company.allSkills.filter((allEntity) => allEntity.id !== id)));
        return obj;
    });
}
